import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=1754a88c"
import script from "./TextInput.vue?vue&type=script&lang=js"
export * from "./TextInput.vue?vue&type=script&lang=js"
import style0 from "./TextInput.vue?vue&type=style&index=0&id=1754a88c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TextInput.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(component)

export default component.exports